import { useHistory, useLocation } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import React, { useEffect, useRef } from 'react'
import './style.scss'

interface PopupProps {
  children: JSX.Element
  save?: basic.BasicFunc
  close?: basic.BasicFunc
}

const Popup: React.FC<PopupProps> = ({ children, save, close: _close }) => {
  const { state } = useLocation<{ popup?: object }>()
  const popupRef = useRef<HTMLDivElement>(null)

  const { t } = useTranslation('filters')
  const { goBack } = useHistory()
  const close = _close || goBack

  useEffect(() => {
    const isHidden = document.body.style.overflow === 'hidden'
    const escDetect = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close()
    }
    if (!isHidden) document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', escDetect, false)

    return () => {
      if (!isHidden) document.body.style.overflow = 'auto'
      document.removeEventListener('keydown', escDetect, false)
    }
  }, [close])

  return (
    <div
      className={`popup__calendar__container popup__bg${state?.popup ? '' : ' --close'}`}
      onClick={e => {
        if (popupRef.current && e.target instanceof Node && !popupRef.current.contains(e.target)) {
          close()
        }
      }}>

      <div
        ref={popupRef}
        className='popup__calendar'>

        <div className='popup__shadow'>
          <div />
          <div />
        </div>

        <div className='popup__main center'>
          {children}
          <div
            className='popup__button'
            onClick={save || goBack}>
            {t('saveChanges')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Popup